import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert, Container } from '@mui/material';
import api from '../../services/api';

/**
 * Short URL handler: /e/:code
 * Exchanges the short code for a JWT token and redirects to /enroll?token=...
 */
export default function EnrollShortRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!code) {
      setError('Missing link');
      return;
    }
    api.get('/api/public/enroll/token-by-code', { params: { code } })
      .then((res) => {
        if (res.data?.success && res.data?.token) {
          navigate(`/enroll?token=${encodeURIComponent(res.data.token)}`, { replace: true });
        } else {
          setError('Invalid or expired link');
        }
      })
      .catch((err) => {
        const msg = err.response?.data?.message || 'Invalid or expired link';
        setError(msg);
      });
  }, [code, navigate]);

  if (error) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ py: 4 }}>
          <Alert severity="error">{error}</Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '40vh' }}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Taking you to the enrollment form...
      </Typography>
    </Box>
  );
}
